

export * from './change-password-ui.component';
export * from './change-password-ui.module';